import { TextInput, createStyles } from "@mantine/core";
import { useDebouncedState } from "@mantine/hooks";
import React, { memo, useEffect } from "react";
import { COLORS } from "../../../colors";

interface IProps {
  onChangeText?: (value: string) => void;
}

const TableSearch: React.FC<IProps> = ({ onChangeText }) => {
  const { classes } = useStyle();
  const [value, setValue] = useDebouncedState("", 400);

  useEffect(() => {
    onChangeText && onChangeText(value);
  }, [value, onChangeText]);

  return (
    <TextInput
      className={classes.root}
      placeholder="search"
      onChange={(e) => {
        setValue(e.target.value);
      }}
    />
  );
};

export default memo(TableSearch);

const useStyle = createStyles({
  root: {
    width: "100%",
    maxWidth: 380,
    marginRight: 10,
    "& input": {
      borderColor: COLORS.borderPrimary,
      borderRadius: 5,
      padding: "0px 15px",
      height: "auto !important",
      fontSize: "14px",
      fontWeight: 300,
    },
  },
});
